export const client_account = {
  id : '',  
  bank: '', 
  address: '', 
  correspondent_account: '', 
  checking_account: '', 
  created_at: '',
  updated_at: ''
};
  